import { callWrapper } from 'api/utils';
import axios from 'axios';

const path = '/api/users';

const users = {
    create: callWrapper((data) => axios.post(`${path}/create`, data)),
    update: callWrapper((id, data) => axios.post(`${path}/edit/${id}`, data)),
    partialUpdate: callWrapper((id, data) =>
        axios.patch(`${path}/${id}`, data)
    ),
    currentUser: callWrapper(() => axios.get(`${path}/current`)),
    changePassword: callWrapper((data) =>
        axios.post(`${path}/change-password`, data)
    ),
    changePasswordEmail: callWrapper((data) =>
        axios.post(`${path}/change-password-email`, data)
    ),
    qlikLoginSSO: callWrapper(() => axios.post(`${path}/qlik-node-sso`)),
    getProfile: callWrapper((id) => axios.get(`${path}/${id}`)),
};

export default users;
